import { Text } from '@oneaudi/unified-web-components';
import { useAtomValue } from 'jotai';
import { useI18n } from '~/app/i18n/i18n';
import { PriceSectionStyle } from '~/app/pages/summary/dialogs/price-detail/components/price-section-style';
import { useFootnotes } from '~/components/footnotes';
import { MONTHLY_RATE_DIALOG_REMARK } from '~/components/footnotes/constants';
import { FootnoteReferenceNgc } from '~/components/footnotes/footnote-reference';
import { state } from '~/storage';

export function RateSection({
	title,
	price,
	bold,
}: {
	/* eslint-disable-next-line react/no-unused-prop-types */
	pricePartType: string;
	title: string;
	price: string | null | undefined;
	bold?: boolean;
}) {
	const { addFootnote, getReference } = useFootnotes();
	const disclaimer = useAtomValue(state.financingDisclaimerText);
	const { i18n } = useI18n();

	addFootnote(MONTHLY_RATE_DIALOG_REMARK, disclaimer);

	return (
		<PriceSectionStyle tabIndex={0}>
			<Text tag="p" variant={{ type: 'copy', order: '2', style: bold ? 'bold' : 'normal' }}>
				{title}
			</Text>
			<Text tag="p" variant={{ type: 'copy', order: '2', style: bold ? 'bold' : 'normal' }}>
				{price}
				<FootnoteReferenceNgc
					reference={getReference(MONTHLY_RATE_DIALOG_REMARK)}
					ariaLabel={i18n('ngc.a11y.footnotes.financing')}
				/>
			</Text>
		</PriceSectionStyle>
	);
}
